import React, { Fragment } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import MobileMenuDrawer from './MobileMenuDrawer';
import config from '../../helpers/config';

// material ui
import PropTypes from 'prop-types';
import { Hidden, Grid, Slide, Container, useScrollTrigger, Typography, Toolbar, AppBar } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';

// add custom style
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    appBar: {
        background: 'rgba(255, 255, 255, 0.9)',
        boxShadow: 'none',
        height: '75px',
        padding: '0px'
    },
    toolBar: {
        height: '75px',
        [theme.breakpoints.down('xs')]: {
            padding: '0px 5px',
        },
        [theme.breakpoints.up('lg')]: {
            padding: '0px',
        },
    },
    toolBarPlaceHolder: {
        height: '67px',

        [theme.breakpoints.up('lg')]: {
            padding: '0px',
        }
    },
    logo: {
        display: 'block',
        height: '75px',
        width: '248px',
        backgroundImage: `url(${config.S3Endpoint}/header/logo-thumbnail.png)`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
    },
    navLink: {
        textDecoration: 'none',
        color: theme.palette.text.primary,
        fontWeight: '400',
        letterSpacing: '5',
        textShadow: '1px 1px 4px #ececec',

        '&.selected': {
            color: theme.palette.text.secondary,
        }
    },
    selected: {
        fontWeight: '400'
    }
}));

function HideOnScroll(props) {

    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({ target: window ? window() : undefined, threshold: 300 });

    return (
        <Slide appear={false} direction="down" in={!trigger}>
            {children}
        </Slide>
    );
}
  
HideOnScroll.propTypes = {
    children: PropTypes.element.isRequired,
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
};

const Header = (props) => {
    const classes = useStyles();
    const { auth } = props;
    const location = useLocation();
    // const authButton = auth ? 
    //     (<a href="/api/logout">Logout</a>) : 
    //     (<a href="/api/auth/google">Login</a>);
    const { headers } = auth;
    return (
        <Fragment>
            <HideOnScroll {...props}>
                <AppBar className={classes.appBar}>
                    <Container maxWidth="lg" className={classes.toolBar} >
                        <Toolbar className={classes.toolBar}>
                            
                            {/* <Typography variant="h4" color="primary"><Link to="/users"> Users </Link></Typography>
                            <Typography variant="h4" color="primary"><Link to="/admins"> Admins </Link></Typography>
                            <Typography variant="h4" color="primary">{authButton}</Typography> */}
                            <Grid container alignItems="center">
                                <Grid item xs={10} sm={10} md={5} lg={5} xl={5}>
                                    <Typography>
                                        <NavLink to="/" className={classes.logo}></NavLink>
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} sm={2} md={7} lg={7} xl={7}>
                                    <Hidden smDown={true} implementation="css">
                                        <Grid container justify="space-around" direction="row">
                                            {headers.map((d) => {
                                                if (d.disabled) {
                                                    return;
                                                }
                                                var link = d.internal ? 
                                                    (<NavLink className={classes.navLink} to={d.linkUrl} target={d.linkTarget} activeClassName="selected">{d.name}</NavLink>) : 
                                                    (<a className={classes.navLink + ' ' + (location.pathname.indexOf(d.linkUrl) !== -1 ? 'selected': '')} rel="noopener" href={d.linkUrl} target={d.linkTarget}>{d.name}</a>)
                                                return <Typography key={d.id} variant="h5" display="inline" align="center">{link}</Typography>
                                            })}
                                        </Grid>
                                    </Hidden>
                                    <Hidden mdUp={true} implementation="css">
                                        <MobileMenuDrawer />
                                    </Hidden>
                                </Grid>
                            </Grid>
                            
                        </Toolbar>
                    </Container>
                </AppBar>
            </HideOnScroll>
            <Toolbar className={classes.toolBarPlaceHolder} />
        </Fragment>
    )
}

function mapStateToProps({ auth }) {
    return { auth };
}

export default connect(mapStateToProps)(Header);


// WEBPACK FOOTER //
// ./src/client/components/Header.js